import { PrivateAPINamespace } from '../PrivateAPINamespace';
import type { WorkspaceHost as WorkspaceHostType } from '@wix/workspace';

interface Workspace extends NonNullable<WorkspaceHostType['workspace']> {}

export class WorkspaceNamespace
  extends PrivateAPINamespace
  implements Workspace
{
  static readonly namespace = 'workspace';

  // @ts-expect-error - TODO: implement this
  getContextIds() {
    throw new Error('Not implemented yet');
  }

  openItemSelector(
    _args: Parameters<NonNullable<Workspace['openItemSelector']>>,
  ) {
    throw new Error('Not implemented yet');
  }
  apps: Workspace['apps'] = {
    startInstallFlow: async (args) => {
      return this.ps.hostAPI.workspace!.apps.startInstallFlow(args);
    },
    startPurchasePlanFlow: async (args) => {
      return this.ps.hostAPI.workspace!.apps.startPurchasePlanFlow(args);
    },
    startUpdateFlow: async (args) => {
      return this.ps.hostAPI.workspace!.apps.startUpdateFlow(args);
    },
    openContactSupport: async (args) => {
      return this.ps.hostAPI.workspace!.apps.openContactSupport(args);
    },
  };
  tools: Workspace['tools'] = {
    editWithWixel: async (args) => {
      return this.ps.hostAPI.workspace!.tools.editWithWixel(args);
    },
  };
}
